<form [formGroup]="form" (submit)="submit()" a11yFocusTrap a11yAutoFocus>
    <vwui-modal-header>
        <h2 a11yPageTitleLevel="2">{{ 'NEW_PROJECT_VERSION.modal.title' | translate }}</h2>
    </vwui-modal-header>

    <vwui-modal-body>
        @if (currentVersion) {
            <vwui-form-group [label]="'NEW_PROJECT_VERSION.modal.current_version' | translate">
                <span class="current-version">{{ currentVersion }}</span>
            </vwui-form-group>
        }

        <vwui-form-group [label]="'NEW_PROJECT_VERSION.modal.bump_kind' | translate">
            <div class="bump-kind-options">
                <label class="bump-option">
                    <input type="radio" formControlName="bumpKind" value="minor"/>
                    <span>{{ 'NEW_PROJECT_VERSION.modal.minor' | translate }}</span>
                </label>
                <label class="bump-option" [class.bump-option--disabled]="!isMajorAllowed">
                    <input type="radio" formControlName="bumpKind" value="major" [attr.disabled]="!isMajorAllowed ? '' : null"/>
                    <span>{{ 'NEW_PROJECT_VERSION.modal.major' | translate }}</span>
                </label>
            </div>
            @if (!isMajorAllowed) {
                <small class="bump-hint">{{ 'NEW_PROJECT_VERSION.modal.major_disabled_hint' | translate }}</small>
            }
        </vwui-form-group>

        <vwui-form-group [label]="'NEW_PROJECT_VERSION.modal.note' | translate" inputId="note">
            <vwui-textarea inputId="note" formControlName="note" class="vwui-textarea--small"></vwui-textarea>
        </vwui-form-group>
    </vwui-modal-body>

    <vwui-modal-footer>
        <vwui-button (click)="modalRef.close(null)" class="is-secondary" type="button">
            {{ 'BUTTON.cancel' | translate }}
        </vwui-button>
        <vwui-button (click)="submit()" class="is-primary" type="submit">
            {{ 'BUTTON.save' | translate }}
        </vwui-button>
    </vwui-modal-footer>
</form>
